import { ReactNode, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

interface TibiaContainerProps {
  children: ReactNode;
  title?: string;
  className?: string;
  collapsible?: boolean;
  defaultCollapsed?: boolean;
  ribbon?: string | null;
}

const TibiaContainer = ({ children, title, className = "", collapsible = false, defaultCollapsed = false, ribbon }: TibiaContainerProps) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <div className={`tibia-border bg-card rounded-sm relative overflow-hidden ${className}`}>
      {ribbon && (
        <div className="pointer-events-none absolute top-0 left-0 w-32 h-32 overflow-hidden z-20">
          <div
            className="absolute font-pixel text-[9px] uppercase tracking-wider text-background bg-gradient-to-r from-amber-500 via-primary to-amber-500 text-center shadow-lg animate-pulse"
            style={{
              transform: "rotate(-45deg)",
              width: "180px",
              left: "-50px",
              top: "28px",
              padding: "4px 0",
              boxShadow: "0 2px 8px hsl(var(--primary) / 0.6)",
              borderTop: "1px solid hsla(0,0%,100%,0.4)",
              borderBottom: "1px solid hsla(0,0%,0%,0.3)",
            }}
          >
            ⭐ {ribbon}
          </div>
        </div>
      )}
      {title && (
        <div
          className={`tibia-border-inner bg-secondary px-4 py-2 -mx-[2px] -mt-[2px] rounded-t-sm ${collapsible ? "cursor-pointer select-none hover:bg-secondary/80 transition-colors" : ""}`}
          onClick={collapsible ? () => setCollapsed(!collapsed) : undefined}
        >
          <div className="flex items-center justify-center gap-2">
            {collapsible && (
              collapsed
                ? <ChevronRight className="w-3.5 h-3.5 text-primary shrink-0" />
                : <ChevronDown className="w-3.5 h-3.5 text-primary shrink-0" />
            )}
            <h2 className="font-pixel text-xs text-primary gold-text-glow tracking-wider text-center uppercase">
              {title}
            </h2>
          </div>
        </div>
      )}
      {!collapsed && (
        <div className="p-4">
          {children}
        </div>
      )}
    </div>
  );
};

export default TibiaContainer;
